import Vue from 'vue'
import App from './App.vue'
import PartnersApp from './PartnersApp.vue'
import router from './router'
import partnersRouter from './partners.router'
import store from '@/store'
import Plugin from '@/common/plugins/plugins'
import utils from '@/common/util/utils'
import { IS_SPECIAL_PROMOTION_PAGE } from '@/common/constant'
import { checkMoveCoverPage, goCoverPage } from '@/common/util/cover'
Vue.config.productionTip = false

utils.redirectWithParams()
utils.allowDeviceCheck()
utils.redirectHttpToHttps()

Plugin.init()

function startMobileWeb () {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

if (IS_SPECIAL_PROMOTION_PAGE) {
  new Vue({
    router: partnersRouter,
    render: h => h(PartnersApp)
  }).$mount('#app')
} else {
  if (location.pathname === '/signup') {
    startMobileWeb()
  } else {
    let autoLoginPromise = utils.login.autoLoginProc()
    if (autoLoginPromise) {
      autoLoginPromise.then(() => {
        window.location.reload(true)
      }).catch(() => {
      })
    } else {
      if (checkMoveCoverPage()) {
        goCoverPage()
      } else {
        startMobileWeb()
      }
    }
  }
}
